import type { StaticSensor } from '@/models/types/plc/static-sensor'
import type { SensoreStaticoDTO } from '../../dto/plc/sensore-statico-dto'
import { calculateSensorName } from './sensor-name-calculator'

const mapToStaticSensor = (dto: SensoreStaticoDTO): StaticSensor => {
    return {
        id: dto.id,
        group: dto.gruppo ?? undefined,
        position: dto.posizione ?? undefined,
        name: calculateSensorName(dto),
        enabled: dto.abilitato,
        offset1: dto.offset1,
        frequency: dto.tFrequency ?? undefined,
        resetFrequency: dto.tResetFrequency ?? undefined,
        maxThreshold: dto.rMaxThreashold,
        minThreshold: dto.rMinThreashold,
        type: dto.type,
        uom: dto.um ?? undefined,
        minScale: dto.fondoScalaMin,
        maxScale: dto.fondoScalaMax,
        number: dto.numero,
        resolution: dto.risoluzione,
        decimals: dto.decimals,
        identifier: dto.aliasId ?? undefined,
    }
}

const mapToSensoreStaticoDTO = (sensor: StaticSensor): SensoreStaticoDTO => {
    return {
        id: sensor.id,
        gruppo: sensor.group ?? null,
        posizione: sensor.position ?? null,
        aliasId: sensor.identifier ?? null,
        abilitato: sensor.enabled,
        offset1: sensor.offset1,
        tFrequency: sensor.frequency ?? null,
        tResetFrequency: sensor.resetFrequency ?? null,
        rMaxThreashold: sensor.maxThreshold,
        rMinThreashold: sensor.minThreshold,
        type: sensor.type,
        um: sensor.uom ?? null,
        fondoScalaMin: sensor.minScale,
        fondoScalaMax: sensor.maxScale,
        numero: sensor.number,
        risoluzione: sensor.resolution,
        decimals: sensor.decimals,
    }
}

export { mapToSensoreStaticoDTO, mapToStaticSensor }
